module.exports = __webpack_public_path__ + "img/18.205aa3d8.jpg";